// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../bundler/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../bundler/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-container {
    box-sizing: border-box;
    font-family: 'Roboto-Regular';
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #04142f;
    line-height: 24px;
    letter-spacing: 0.02em;
    margin: 0;
    padding-bottom: 40px;
    position: relative;
    padding-right: 16px;
    height: 100%;
}
.ql-note-editor-mobile {
    padding: 0 0 40px 0;
}
.ql-container.ql-disabled .ql-tooltip {
    visibility: hidden;
}
.ql-container.ql-disabled .ql-editor li[data-list] > .ql-ui {
    pointer-events: none;
}
.ql-clipboard {
    left: -100000px;
    height: 1px;
    overflow-y: hidden;
    position: absolute;
    top: 50%;
}
.ql-clipboard p {
    margin: 0;
    padding: 0;
}
.ql-editor {
    box-sizing: border-box;
    line-height: 1.6;
    height: 100%;
    outline: none;
    overflow-y: auto;
    padding: 12px 0;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-top: 20px;
    overflow-x: hidden;
    -webkit-user-select: text;
    padding-left: 104px;
    padding-right: 104px;
}
@media only screen and (max-width: 1052px) {
    .ql-editor {
        padding-right: 56px;
        padding-left: 56px;
    }
}
@media only screen and (max-width: 819px) {
    .ql-editor {
        padding-right: 0px;
        padding-left: 0px;
    }

    .ql-editor.ql-editor-collapsed {
        padding-right: 56px;
        padding-left: 56px;
    }
}
.ql-editor > * {
    cursor: text;
}
.ql-editor .ql-markdownTable {
    display: block;
    margin: 12px 0;
    max-width: 100%;
    cursor: default;
}
.ql-editor .ql-markdown-table-scroll {
    max-width: 100%;
    overflow-x: auto;
    padding-bottom: 2px;
}
.ql-editor .ql-markdown-table {
    width: max-content;
    min-width: min(100%, 320px);
    max-width: 100%;
    border-collapse: collapse;
    border: 1px solid #d7dff0;
    color: #04142f;
    font-size: 14px;
    line-height: 20px;
    white-space: normal;
}
.ql-editor .ql-markdown-table th,
.ql-editor .ql-markdown-table td {
    min-width: 96px;
    max-width: 280px;
    border: 1px solid #d7dff0;
    padding: 8px 10px;
    vertical-align: top;
    overflow-wrap: anywhere;
}
.ql-editor .ql-markdown-table th {
    background-color: #f6f8fc;
    font-weight: 700;
}
/* Quill 2 list DOM: every list renders as <ol>, the type lives in li[data-list]
   (ordered | bullet | checked | unchecked), and the marker is drawn by the
   contenteditable=false <span class="ql-ui"> child. The app's custom metrics
   (7.4px list padding, 1.82em item padding, 9.7px marker gap) are preserved on
   the new selectors. */
.ql-editor {
    counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
    margin: 0;
    padding: 0;
}
.ql-editor p,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
    counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
/* AT-2254: a numbered list must restart at 1 unless it directly continues an
   ordered list. Quill 2's ListContainer only ever accepts ListItem children
   (ListContainer.allowedChildren = [ListItem]), so ANY other block -- a
   paragraph, heading, blockquote, code block, markdown table, divider or image
   -- necessarily splits the list into a second <ol>. Resetting the counter on
   the container therefore covers every possible separator, where the previous
   \`p, h1..h6\` rule above covered only two of them and let a list that was
   interrupted by anything else keep counting (1..6 at the top of a note, then
   7.. much further down). Kept alongside that rule rather than replacing it:
   it is what stock quill ships, and it costs nothing. */
.ql-editor ol {
    padding-left: 7.4px; /*Previous value was 0.25em*/
    counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor li {
    list-style-type: none;
    position: relative;
}
.ql-editor li > .ql-ui::before {
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
    text-align: right;
}
.ql-editor li[data-list='ordered'] > .ql-ui::before {
    margin-left: -1.65em;
    margin-right: 0.45em;
}
.ql-editor li[data-list='bullet'] > .ql-ui::before {
    content: '\\2022';
    margin-left: -1.5em;
    margin-right: 9.7px;
}
.ql-editor li[data-list='checked'] > .ql-ui,
.ql-editor li[data-list='unchecked'] > .ql-ui {
    color: #777;
    cursor: pointer;
    pointer-events: all;
}
.ql-editor li[data-list='checked'] > .ql-ui::before {
    content: '\\2611';
    margin-left: -1.5em;
    margin-right: 9.7px;
}
.ql-editor li[data-list='unchecked'] > .ql-ui::before {
    content: '\\2610';
    margin-left: -1.5em;
    margin-right: 9.7px;
}
.ql-editor li.ql-direction-rtl > .ql-ui::before {
    margin-left: 0.3em;
    margin-right: -1.5em;
    text-align: left;
}
.ql-editor li:not(.ql-direction-rtl) {
    padding-left: 1.82em;
}
.ql-editor li.ql-direction-rtl {
    padding-right: 1.82em;
}
.ql-editor li[data-list] {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
/* AT-2254: the one separator that does NOT split the <ol>. Quill 2 keeps
   bullets, checkboxes and numbers in a single container and distinguishes them
   only by li[data-list], so a bulleted or checklist run between two numbered
   runs leaves them in the same <ol> and the container reset above never fires.
   \`counter-set\` is deliberate: it touches list-0 alone, so it cannot collide
   with the list-1..list-9 \`counter-reset\` cascade above and in the indent chain
   below (same property + equal specificity would drop the nested resets). */
.ql-editor li[data-list='bullet'],
.ql-editor li[data-list='checked'],
.ql-editor li[data-list='unchecked'] {
    counter-set: list-0 0;
}
/* Safari < 17.2 has no counter-set. Falling back to counter-reset re-introduces
   the collision described above, so an INDENTED bullet loses its list-1..list-9
   reset there; top-level separation -- the reported bug -- still works. */
@supports not (counter-set: none) {
    .ql-editor li[data-list='bullet'],
    .ql-editor li[data-list='checked'],
    .ql-editor li[data-list='unchecked'] {
        counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    }
}
.ql-editor li[data-list='ordered'] {
    counter-increment: list-0;
}
.ql-editor li[data-list='ordered'] > .ql-ui::before {
    content: counter(list-0, decimal) '. ';
}
.ql-editor li[data-list='ordered'].ql-indent-1 {
    counter-increment: list-1;
}
.ql-editor li[data-list='ordered'].ql-indent-1 > .ql-ui::before {
    content: counter(list-1, lower-alpha) '. ';
}
.ql-editor li[data-list].ql-indent-1 {
    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-2 {
    counter-increment: list-2;
}
.ql-editor li[data-list='ordered'].ql-indent-2 > .ql-ui::before {
    content: counter(list-2, lower-roman) '. ';
}
.ql-editor li[data-list].ql-indent-2 {
    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-3 {
    counter-increment: list-3;
}
.ql-editor li[data-list='ordered'].ql-indent-3 > .ql-ui::before {
    content: counter(list-3, decimal) '. ';
}
.ql-editor li[data-list].ql-indent-3 {
    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-4 {
    counter-increment: list-4;
}
.ql-editor li[data-list='ordered'].ql-indent-4 > .ql-ui::before {
    content: counter(list-4, lower-alpha) '. ';
}
.ql-editor li[data-list].ql-indent-4 {
    counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-5 {
    counter-increment: list-5;
}
.ql-editor li[data-list='ordered'].ql-indent-5 > .ql-ui::before {
    content: counter(list-5, lower-roman) '. ';
}
.ql-editor li[data-list].ql-indent-5 {
    counter-reset: list-6 list-7 list-8 list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-6 {
    counter-increment: list-6;
}
.ql-editor li[data-list='ordered'].ql-indent-6 > .ql-ui::before {
    content: counter(list-6, decimal) '. ';
}
.ql-editor li[data-list].ql-indent-6 {
    counter-reset: list-7 list-8 list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-7 {
    counter-increment: list-7;
}
.ql-editor li[data-list='ordered'].ql-indent-7 > .ql-ui::before {
    content: counter(list-7, lower-alpha) '. ';
}
.ql-editor li[data-list].ql-indent-7 {
    counter-reset: list-8 list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-8 {
    counter-increment: list-8;
}
.ql-editor li[data-list='ordered'].ql-indent-8 > .ql-ui::before {
    content: counter(list-8, lower-roman) '. ';
}
.ql-editor li[data-list].ql-indent-8 {
    counter-reset: list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-9 {
    counter-increment: list-9;
}
.ql-editor li[data-list='ordered'].ql-indent-9 > .ql-ui::before {
    content: counter(list-9, decimal) '. ';
}
.ql-editor .ql-ui {
    position: absolute;
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3.32em;
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3.32em;
}
.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 3.32em;
}
.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 3.32em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 3.32em;
}
.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 4.82em;
}
.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 4.82em;
}
.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 4.82em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 4.82em;
}
.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 6.32em;
}
.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 6.32em;
}
.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 6.32em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 7.82em;
}
.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 7.82em;
}
.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 7.82em;
}
.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 7.82em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 9.32em;
}
.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 9.32em;
}
.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 9.32em;
}
.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 9.32em;
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 10.82em;
}
.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 10.82em;
}
.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 10.82em;
}
.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 10.82em;
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 12.32em;
}
.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 12.32em;
}
.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 12.32em;
}
.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 12.32em;
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 13.82em;
}
.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 13.82em;
}
.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 13.82em;
}
.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 13.82em;
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 15.32em;
}
.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 15.32em;
}
.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 15.32em;
}
.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 15.32em;
}
.ql-editor .ql-video {
    display: block;
    max-width: 100%;
}
.ql-editor .ql-video.ql-align-center {
    margin: 0 auto;
}
.ql-editor .ql-video.ql-align-right {
    margin: 0 0 0 auto;
}
.ql-editor .ql-bg-black {
    background-color: #000;
}
.ql-editor .ql-bg-red {
    background-color: #e60000;
}
.ql-editor .ql-bg-orange {
    background-color: #f90;
}
.ql-editor .ql-bg-yellow {
    background-color: #ff0;
}
.ql-editor .ql-bg-green {
    background-color: #008a00;
}
.ql-editor .ql-bg-blue {
    background-color: #06c;
}
.ql-editor .ql-bg-purple {
    background-color: #93f;
}
.ql-editor .ql-color-white {
    color: #fff;
}
.ql-editor .ql-color-red {
    color: #e60000;
}
.ql-editor .ql-color-orange {
    color: #f90;
}
.ql-editor .ql-color-yellow {
    color: #ff0;
}
.ql-editor .ql-color-green {
    color: #008a00;
}
.ql-editor .ql-color-blue {
    color: #06c;
}
.ql-editor .ql-color-purple {
    color: #93f;
}
.ql-editor .ql-font-serif {
    font-family: Georgia, Times New Roman, serif;
}
.ql-editor .ql-font-monospace {
    font-family: Monaco, Courier New, monospace;
}
.ql-editor .ql-size-small {
    font-size: 0.75em;
}
.ql-editor .ql-size-large {
    font-size: 1.5em;
}
.ql-editor .ql-size-huge {
    font-size: 2.5em;
}
.ql-editor .ql-direction-rtl {
    direction: rtl;
    text-align: inherit;
}
.ql-editor .ql-align-center {
    text-align: center;
}
.ql-editor .ql-align-justify {
    text-align: justify;
}
.ql-editor .ql-align-right {
    text-align: right;
}
.ql-editorLoading.ql-blank::before {
    color: rgba(0, 0, 0, 0.6) !important;
}
.ql-editor.ql-blank::before {
    color: rgba(0, 0, 0, 0);
    content: attr(data-placeholder);
    font-style: italic;
    left: 15px;
    pointer-events: none;
    position: absolute;
    right: 15px;
}
@media only screen and (min-width: 1052px) {
    .ql-editor.ql-blank::before {
        padding-left: 88px;
    }
}
@media only screen and (max-width: 1052px) {
    .ql-editor.ql-blank::before {
        padding-left: 40px;
    }
}
@media only screen and (max-width: 819px) {
    .ql-editor.ql-blank::before {
        left: -40px;
    }
    .ql-editor.ql-editor-collapsed.ql-blank::before {
        left: 0px;
        padding-left: 56px;
    }
}
.ql-snow.ql-toolbar:after,
.ql-snow .ql-toolbar:after {
    clear: both;
    content: '';
    display: table;
}
.ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
    background: none;
    border: none;
    cursor: pointer;
    display: inline-block;
    float: left;
    height: 20px;
    padding: 0 6px;
    min-width: 32px;
}
.ql-snow.ql-toolbar .ql-toolbar-item {
    position: relative;
}
.ql-snow.ql-toolbar button svg,
.ql-snow .ql-toolbar button svg {
    float: left;
    height: 100%;
}
.ql-snow.ql-toolbar button:active:hover,
.ql-snow .ql-toolbar button:active:hover {
    outline: none;
}
.ql-snow.ql-toolbar input.ql-image[type='file'],
.ql-snow .ql-toolbar input.ql-image[type='file'] {
    display: none;
}
.ql-snow.ql-toolbar button:hover,
.ql-snow .ql-toolbar button:hover,
.ql-snow.ql-toolbar button:focus,
.ql-snow .ql-toolbar button:focus,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow .ql-toolbar button.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow .ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow .ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
    color: #06c;
}
.ql-snow.ql-toolbar button:hover .ql-fill,
.ql-snow .ql-toolbar button:hover .ql-fill,
.ql-snow.ql-toolbar button:focus .ql-fill,
.ql-snow .ql-toolbar button:focus .ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
    fill: #06c;
}
.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button:focus .ql-stroke,
.ql-snow .ql-toolbar button:focus .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter,
.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
    stroke: #06c;
    transition: 0.3s;
}
@media (pointer: coarse) {
    .ql-snow.ql-toolbar button:hover:not(.ql-active),
    .ql-snow .ql-toolbar button:hover:not(.ql-active) {
        color: #444;
    }
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
        fill: #444;
    }
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
        stroke: #444;
    }
}
.ql-snow {
    box-sizing: border-box;
}
.ql-snow * {
    box-sizing: border-box;
}
.ql-snow .ql-hidden {
    display: none;
}
.ql-hide {
    display: none !important;
}
.ql-transparent {
    opacity: 0 !important;
}
.ql-snow .ql-out-bottom,
.ql-snow .ql-out-top {
    visibility: hidden;
}
.ql-snow .ql-tooltip {
    position: absolute;
    transform: translate(148px, 10px);
}
.ql-snow .ql-tooltip a {
    cursor: pointer;
    text-decoration: none;
}
.ql-snow .ql-tooltip.ql-flip {
    transform: translateY(-10px);
}
.ql-snow .ql-formats {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.ql-snow .ql-formats:after {
    clear: both;
    content: '';
    display: table;
}
.ql-snow .ql-stroke {
    transition: 0.3s;
    fill: none;
    stroke: #8a94a6;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 0.2px;
}
.ql-snow .ql-stroke-miter {
    fill: none;
    stroke: #444;
    stroke-miterlimit: 10;
    stroke-width: 2;
}
.ql-snow .ql-fill,
.ql-snow .ql-stroke.ql-fill {
    fill: #8a94a6;
}
.ql-snow .ql-empty {
    fill: none;
}
.ql-snow .ql-even {
    fill-rule: evenodd;
}
.ql-snow .ql-thin,
.ql-snow .ql-stroke.ql-thin {
    stroke-width: 1;
}
.ql-snow .ql-transparent {
    opacity: 0.4;
}
.ql-snow .ql-direction svg:last-child {
    display: none;
}
.ql-snow .ql-direction.ql-active svg:last-child {
    display: inline;
}
.ql-snow .ql-direction.ql-active svg:first-child {
    display: none;
}
.ql-snow .ql-editor h1 {
    font-family: 'Roboto-Medium', 'Roboto-Regular';
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: -0.01em;
    color: #04142f;
    margin-top: 24px;
    margin-bottom: 8px;
}
.ql-snow .ql-editor h2 {
    font-family: 'Roboto-Medium', 'Roboto-Regular';
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 30px;
    letter-spacing: 0em;
    color: #1a2744;
    margin-top: 20px;
    margin-bottom: 6px;
}
.ql-snow .ql-editor h3 {
    font-family: 'Roboto-Regular';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 0em;
    color: #4e5d78;
    margin-top: 16px;
    margin-bottom: 4px;
}
/* Keep in-document heading rhythm, but avoid excessive top gap at the start of a note. */
.ql-snow .ql-editor > h1:first-child,
.ql-snow .ql-editor > h2:first-child,
.ql-snow .ql-editor > h3:first-child {
    margin-top: 8px;
}
.ql-snow .ql-editor h4 {
    font-size: 1em;
}
.ql-snow .ql-editor h5 {
    font-size: 0.83em;
}
.ql-snow .ql-editor h6 {
    font-size: 0.67em;
}
.ql-snow .ql-editor a {
    text-decoration: underline;
}
.ql-snow .ql-editor blockquote {
    border-left: 4px solid #ccc;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
}
.ql-snow .ql-editor code,
.ql-snow .ql-editor pre {
    background-color: #f0f0f0;
    border-radius: 3px;
}
.ql-snow .ql-editor pre {
    white-space: pre-wrap;
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 5px 10px;
}
.ql-snow .ql-editor code {
    font-size: 85%;
    padding: 2px 4px;
}
.ql-snow .ql-editor pre.ql-syntax {
    background-color: #23241f;
    color: #f8f8f2;
    overflow: visible;
}
.ql-snow .ql-editor img {
    max-width: 100%;
}
.ql-snow .ql-picker {
    color: #4e5d78;
    display: inline-block;
    float: left;
    font-size: 16px;
    font-weight: normal;
    height: 28px;
    position: relative;
    vertical-align: middle;
    letter-spacing: 0.02em;
}
.ql-snow .ql-picker-label {
    cursor: pointer;
    display: flex;
    height: 100%;
    padding-left: 10px;
    padding-right: 2px;
    position: relative;
    width: 100%;
}
.ql-color.ql-picker.ql-color-picker .ql-picker-label {
    display: contents;
}
.ql-background.ql-picker.ql-color-picker .ql-picker-label {
    display: contents;
}
.ql-snow .ql-picker-label::before {
    display: inline-block;
    line-height: 22px;
}
.ql-snow .ql-picker-options {
    background-color: #fff;
    display: none;
    min-width: 100%;
    padding: 4px 8px;
    position: absolute;
    white-space: nowrap;
}
.ql-snow .ql-picker-options .ql-picker-item {
    cursor: pointer;
    display: block;
    padding-bottom: 5px;
    padding-top: 5px;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label {
    color: #ccc;
    z-index: 2;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
    fill: #ccc;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
    stroke: #ccc;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    display: block;
    margin-top: -1px;
    top: 100%;
    z-index: 1;
}
.ql-snow .ql-color-picker,
.ql-snow .ql-icon-picker {
    width: 30px;
}
.ql-snow .ql-color-picker .ql-picker-label,
.ql-snow .ql-icon-picker .ql-picker-label {
    padding: 2px 4px;
}
.ql-snow .ql-color-picker .ql-picker-label svg,
.ql-snow .ql-icon-picker .ql-picker-label svg {
    right: 4px;
}
.ql-snow .ql-icon-picker .ql-picker-options {
    padding: 4px 0px;
}
.ql-snow .ql-icon-picker .ql-picker-item {
    height: 24px;
    width: 24px;
    padding: 2px 4px;
}
.ql-snow .ql-color-picker .ql-picker-options {
    padding: 8px 16px;
    width: 187px;
}
@media (max-width: 818px) {
    .ql-snow .ql-color-picker .ql-picker-options {
        width: 152px;
    }
}
.ql-snow .ql-color-picker .ql-picker-item .ql-color-item-text {
    font-family: 'Roboto-Medium', sans-serif;
    font-weight: 500;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #ffffff !important;
    margin-left: 8px;
}
.ql-snow .ql-color-picker .ql-picker-item .ql-color-item-color {
    display: inline-block;
    border: 2px solid #ffffff;
    border-radius: 50px;
    width: 20px;
    height: 20px;
    margin: 0;
    padding: 0px;
}
.ql-snow .ql-color-picker .ql-picker-item.ql-selected .ql-color-item-text {
    color: #007fff !important;
}
.ql-snow .ql-color-picker .ql-picker-item.ql-selected .ql-color-item-color {
    border-color: #007fff;
}
.ql-snow .ql-color-picker .ql-picker-item .ql-color-item-sub-container {
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: row;
    flex-grow: 1;
    width: 100%;
}
.ql-snow .ql-color-picker .ql-picker-item {
    background-color: transparent !important;
    position: relative;
    margin: 0;
    padding: 10px 0;
}
.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker):not(.ql-header) svg {
    position: absolute;
    margin-top: -9px;
    right: 20px;
    top: 16px;
    width: 18px;
}
.ql-snow .ql-picker.ql-header .ql-picker-options {
    position: absolute;
    top: 40px;
    background-color: #091540;
    padding: 8px 16px;
    min-width: 200px;
    height: 176px;
    border-radius: 4px;
}
@media (max-width: 818px) {
    .ql-snow .ql-picker.ql-header .ql-picker-options {
        min-width: 160px;
    }
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before {
    transform: translate(5px, 8px);
    content: attr(data-label);
    height: 40px;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
    content: attr(data-label);
}
.ql-snow .ql-picker.ql-header {
    width: 12px;
    height: 40px;
}
.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: 'Normal';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1'],
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2'],
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3'],
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=''] {
    position: relative;
    height: 40px;
    margin: 0;
    padding: 0;
    border: none;
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='']::before {
    display: none;
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1'],
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2'],
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3'],
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=''] {
    position: relative;
    height: 40px;
    margin: 0;
    padding: 0 0 0 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.ql-snow .ql-picker.ql-header .ql-picker-item .ql-header-item-icon {
    position: absolute;
    left: 0;
    top: 8px;
    width: 24px;
}

.ql-snow .ql-picker.ql-header .ql-picker-label .ql-header-item-icon {
    position: absolute;
    left: 0 !important;
    top: 11px !important;
    width: 20px !important;
}

.ql-snow .ql-picker.ql-header .ql-picker-label .ql-header-item-icon svg > path {
    fill: #8a94a6 !important;
    stroke: #8a94a6 !important;
}

.ql-snow .ql-picker.ql-header .ql-picker-item .ql-header-item-shortcut {
    position: absolute;
    top: 11px;
    right: 0;
}
.ql-snow .ql-picker.ql-color .ql-picker-item .ql-color-item-shortcut,
.ql-snow .ql-picker.ql-background .ql-picker-item .ql-color-item-shortcut {
    position: absolute;
    top: 3px;
    right: 0;
}

@media (max-width: 818px) {
    .ql-snow .ql-picker.ql-color .ql-picker-item .ql-color-item-shortcut,
    .ql-snow .ql-picker.ql-background .ql-picker-item .ql-color-item-shortcut,
    .ql-snow .ql-picker.ql-header .ql-picker-item .ql-header-item-shortcut {
        display: none;
    }
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
    font-family: 'Roboto-Medium', sans-serif;
    font-weight: 500;
    font-size: 20px !important;
    line-height: 28px !important;
    color: #ffffff !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
    font-family: 'Roboto-Medium', sans-serif;
    font-weight: 500;
    font-size: 18px !important;
    line-height: 26px !important;
    color: #ffffff !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
    font-family: 'Roboto-Medium', sans-serif;
    font-weight: 500;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #ffffff !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='']::before {
    font-family: 'Roboto-Regular', sans-serif;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #ffffff !important;
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
    content: 'Heading';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
    content: 'Subheading';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
    content: 'Small heading';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='']::before {
    content: 'Normal text';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
    content: 'Heading 4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
    content: 'Heading 5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
    content: 'Heading 6';
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
    font-size: 2em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
    font-size: 1.5em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
    font-size: 1.17em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='']::before {
    font-size: 1em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
    font-size: 1em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
    font-size: 0.83em;
}
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
    font-size: 0.67em;
}
.ql-snow .ql-picker.ql-font {
    width: 108px;
}
.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: 'Sans Serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
    content: 'Serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
    content: 'Monospace';
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
    font-family: Georgia, Times New Roman, serif;
}
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
    font-family: Monaco, Courier New, monospace;
}
.ql-snow .ql-picker.ql-size {
    width: 98px;
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: 'Normal';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
    content: 'Small';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
    content: 'Large';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
    content: 'Huge';
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
    font-size: 10px;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
    font-size: 18px;
}
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
    font-size: 32px;
}
.ql-snow .ql-color-picker .ql-picker-options {
    background-color: #091540;
    border-radius: 4px;
}
.ql-snow .ql-color-picker.ql-background .ql-picker-item {
    background-color: #fff;
}
.ql-snow .ql-color-picker.ql-color .ql-picker-item {
    background-color: #000;
}
.ql-toolbar-container::-webkit-scrollbar {
    display: none;
}
.ql-toolbar-container {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    overflow: visible !important;
    /*overflow-x: scroll;*/
    /* width: 100%; */
    /* margin-left: 72px; */
    padding-right: 104px;
    padding-left: 104px;
    /*padding-bottom: 300px;*/
    /*margin-bottom: -300px;*/
}
.ql-toolbar-scroll-indicator {
    width: 48px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fafbfb;
    box-shadow: -2px 0px 4px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    position: absolute;
    right: 0px;
}
@media only screen and (min-width: 1098px) {
    .ql-toolbar-scroll-indicator {
        display: none;
    }
}
@media only screen and (max-width: 1052px) {
    .ql-toolbar-container {
        padding-right: 56px;
        padding-left: 56px;
    }
}
@media only screen and (max-width: 819px) {
    .ql-toolbar-container {
        padding-right: 0px;
        padding-left: 0px;
    }

    .ql-toolbar-container.ql-toolbar-container-collapsed {
        padding-right: 56px;
        padding-left: 56px;
    }
}
.ql-toolbar.ql-snow {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-grow: 1;
    border: 0px;
    height: 56px;
    /*min-width: 700px;*/
    font-family: 'Roboto-Regular', serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.02em;
    padding-left: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 0px;

    background: #fafbfb;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04), 0px 2px 3px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
}
.ql-toolbar.ql-snow .ql-formats {
    margin-right: 15px;
}
.ql-toolbar.ql-snow .ql-formats2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 7px;
    margin-left: -5px;
}

.ql-toolbar.ql-snow .ql-formats3 {
    display: flex;
    flex-direction: row;
    margin-right: 7px;
    margin-left: -5px;
}

.ql-toolbar.ql-snow .ql-formats-editors {
    margin-left: -15px;
}

.ql-toolbar.ql-snow .ql-picker-label {
    border: 1px solid #c6cdd2;
    border-radius: 4px;
}
.ql-toolbar.ql-snow .ql-picker-options {
    border: 1px solid transparent;
    box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
    border-color: #ccc;
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    border-color: #ccc;
}
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
    border-color: #000;
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-top: 0px;
}
.ql-snow .ql-tooltip {
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 5px #ddd;
    color: #444;
    padding: 5px 12px;
    white-space: nowrap;
}
.ql-snow .ql-tooltip::before {
    content: 'Visit URL:';
    line-height: 26px;
    margin-right: 8px;
}
.ql-snow .ql-tooltip input[type='text'] {
    display: none;
    border: 1px solid #ccc;
    font-size: 13px;
    height: 26px;
    margin: 0px;
    padding: 3px 5px;
    width: 170px;
}
.ql-snow .ql-tooltip a.ql-preview {
    display: inline-block;
    max-width: 200px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
}
.ql-snow .ql-tooltip a.ql-action::after {
    border-right: 1px solid #ccc;
    content: 'Edit';
    margin-left: 16px;
    padding-right: 8px;
}
.ql-snow .ql-tooltip a.ql-remove::before {
    content: 'Remove';
    margin-left: 8px;
}
.ql-snow .ql-tooltip a {
    line-height: 26px;
}
.ql-snow .ql-tooltip.ql-editing a.ql-preview,
.ql-snow .ql-tooltip.ql-editing a.ql-remove {
    display: none;
}
.ql-snow .ql-tooltip.ql-editing input[type='text'] {
    display: inline-block;
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: 'Save';
    padding-right: 0px;
}
.ql-snow .ql-tooltip[data-mode='link']::before {
    content: 'Enter link:';
}
.ql-snow .ql-tooltip[data-mode='formula']::before {
    content: 'Enter formula:';
}
.ql-snow .ql-tooltip[data-mode='video']::before {
    content: 'Enter video:';
}
.ql-snow a {
    font-family: 'Roboto-Regular';
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #007fff;
    text-decoration: none;
}

.ql-snow a:link {
    text-decoration: none;
}
.ql-container.ql-snow {
    border: 0px;
}

.ql-custom-popup {
    position: absolute;
    top: 28px;
    left: 28px;
    background-color: #091540;
    border-radius: 4px;
    padding: 8px 16px;
    white-space: nowrap;
    z-index: 10000;
}

.ql-custom-popup .ql-custom-popup-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    justify-content: flex-start;
    position: relative;
}
.ql-custom-popup .ql-custom-popup-text {
    font-family: 'Roboto-Medium', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: #ffffff;
    margin-left: 8px;
    transition: 0.3s;
}
.ql-custom-popup .ql-custom-popup-text.ql-embed {
    position: absolute;
    top: 8px;
    left: 24px;
    width: 120px;
    text-align: left;
}
.ql-custom-popup .ql-active .ql-custom-popup-text.ql-embed {
    color: #007fff;
}
.ql-custom-popup .ql-custom-popup-item .ql-active svg path {
    fill: #007fff !important;
    stroke: #007fff;
}
.ql-custom-popup .ql-custom-popup-item svg path {
    fill: #ffffff !important;
    stroke: #ffffff;
}

.ql-custom-popup .ql-custom-popup-item .ql-picker .ql-custom-popup-text.ql-embed {
    top: 4px;
}

.ql-custom-popup .ql-custom-popup-item .ql-picker .ql-picker-label .ql-custom-popup-text.ql-embed {
    top: 0;
}

.ql-custom-popup .ql-custom-popup-item .ql-picker .ql-picker-label svg {
    top: -4px;
    position: relative;
    left: -4px;
    width: 32px;
}

.ql-custom-popup .ql-custom-popup-item button {
    padding: 0px;
}

.ql-custom-popup .ql-custom-popup-item .ql-picker-options {
    width: 180px;
    top: -16px !important;
    left: -14px;
}

/* Cell editing stays inside the existing table; controls wrap on phones. */
.ql-editor[contenteditable='true'] .ql-markdown-table [data-row][data-column] {
    cursor: text;
}
.ql-editor .ql-markdown-table [data-row][data-column]:focus,
.ql-editor .ql-markdown-table [data-row][data-column]:focus-within {
    outline: 2px solid #8a9eff;
    outline-offset: -2px;
}
.ql-editor .ql-table-cell-input {
    display: block;
    box-sizing: border-box;
    width: 100%;
    min-width: 76px;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 0;
    outline: none;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: inherit;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    overflow: hidden;
    resize: none;
    min-height: 20px;
}
.ql-editor .ql-markdown-table th,
.ql-editor .ql-markdown-table td {
    white-space: pre-wrap;
}
.ql-editor .ql-table-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 6px 0;
    white-space: normal;
}
.ql-editor .ql-table-controls button,
.ql-container .ql-table-draft-recovery button {
    padding: 5px 8px;
    border: 1px solid #d7dff0;
    border-radius: 4px;
    background: #f6f8fc;
    color: #04142f;
    font: inherit;
    font-size: 12px;
    cursor: pointer;
}
.ql-editor .ql-table-controls button[aria-pressed='true'] {
    background: #e8edff;
    border-color: #8a9eff;
}
.ql-editor .ql-table-controls button:disabled {
    opacity: 0.45;
    cursor: default;
}
.ql-container.ql-disabled .ql-table-controls {
    display: none;
}
.ql-container .ql-table-draft-recovery {
    padding: 12px;
    margin: 12px 0;
    border: 1px solid #d7dff0;
    border-radius: 4px;
    background: #f6f8fc;
}
.ql-container .ql-table-draft-recovery textarea {
    box-sizing: border-box;
    width: 100%;
    padding: 8px;
    margin: 8px 0;
}
`, "",{"version":3,"sources":["webpack://./components/NotesView/NotesDV/EditorView/toolbar-styles.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;;IAEI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;;;;uBAIuB;AACvB;IACI,oFAAoF;AACxF;AACA;;;;;;;;;;;IAWI,SAAS;IACT,UAAU;AACd;AACA;;;;;;;IAOI,oFAAoF;AACxF;AACA;;;;;;;;;wDASwD;AACxD;IACI,mBAAmB,EAAE,4BAA4B;IACjD,oFAAoF;AACxF;AACA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,6EAA6E;AACjF;AACA;;;;;;4EAM4E;AAC5E;;;IAGI,qBAAqB;AACzB;AACA;;0EAE0E;AAC1E;IACI;;;QAGI,oFAAoF;IACxF;AACJ;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,sEAAsE;AAC1E;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,+DAA+D;AACnE;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,wDAAwD;AAC5D;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,mCAAmC;AACvC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,4CAA4C;AAChD;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,SAAS;QACT,kBAAkB;IACtB;AACJ;AACA;;IAEI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;AACA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,WAAW;IACX,YAAY;AAChB;AACA;;IAEI,aAAa;AACjB;AACA;;IAEI,aAAa;AACjB;AACA;;;;;;;;;;;;;;IAcI,WAAW;AACf;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA4BI,UAAU;AACd;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA4BI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI;;QAEI,WAAW;IACf;IACA;;;;QAII,UAAU;IACd;IACA;;;;QAII,YAAY;IAChB;AACJ;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,qBAAqB;AACzB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,iCAAiC;AACrC;AACA;IACI,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,eAAe;AACnB;AACA;;IAEI,aAAa;AACjB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA,yFAAyF;AACzF;;;IAGI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;;IAEI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;AACA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,SAAS;IACT,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;;;;IAKI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;;IAEI,iBAAiB;AACrB;;AAEA;;;;IAII,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;;;;IAII,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;AACA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI;;;QAGI,aAAa;IACjB;AACJ;;AAEA;;IAEI,wCAAwC;IACxC,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;;IAEI,wCAAwC;IACxC,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;;IAEI,wCAAwC;IACxC,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;;IAEI,yCAAyC;IACzC,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,qBAAqB;AACzB;AACA;;IAEI,wBAAwB;AAC5B;AACA;;IAEI,sBAAsB;AAC1B;AACA;;IAEI,oBAAoB;AACxB;AACA;;IAEI,oBAAoB;AACxB;AACA;;IAEI,oBAAoB;AACxB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;;IAEI,qBAAqB;AACzB;AACA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,oBAAoB;AACxB;AACA;IACI,4CAA4C;AAChD;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,WAAW;AACf;AACA;;IAEI,iBAAiB;AACrB;AACA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;AACA;IACI,wBAAwB,EAAE,gBAAgB;IAC1C,qBAAqB,EAAE,YAAY;IACnC,4BAA4B;IAC5B,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;IAC5C,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;;IAElB,mBAAmB;IACnB,4EAA4E;IAC5E,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,wCAAwC;AAC5C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;;IAEI,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,WAAW;AACf;;AAEA,2EAA2E;AAC3E;IACI,YAAY;AAChB;AACA;;IAEI,0BAA0B;IAC1B,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,cAAc;IACd,mBAAmB;AACvB;AACA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;IACf,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".ql-container {\n    box-sizing: border-box;\n    font-family: 'Roboto-Regular';\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    color: #04142f;\n    line-height: 24px;\n    letter-spacing: 0.02em;\n    margin: 0;\n    padding-bottom: 40px;\n    position: relative;\n    padding-right: 16px;\n    height: 100%;\n}\n.ql-note-editor-mobile {\n    padding: 0 0 40px 0;\n}\n.ql-container.ql-disabled .ql-tooltip {\n    visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor li[data-list] > .ql-ui {\n    pointer-events: none;\n}\n.ql-clipboard {\n    left: -100000px;\n    height: 1px;\n    overflow-y: hidden;\n    position: absolute;\n    top: 50%;\n}\n.ql-clipboard p {\n    margin: 0;\n    padding: 0;\n}\n.ql-editor {\n    box-sizing: border-box;\n    line-height: 1.6;\n    height: 100%;\n    outline: none;\n    overflow-y: auto;\n    padding: 12px 0;\n    tab-size: 4;\n    -moz-tab-size: 4;\n    text-align: left;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    margin-top: 20px;\n    overflow-x: hidden;\n    -webkit-user-select: text;\n    padding-left: 104px;\n    padding-right: 104px;\n}\n@media only screen and (max-width: 1052px) {\n    .ql-editor {\n        padding-right: 56px;\n        padding-left: 56px;\n    }\n}\n@media only screen and (max-width: 819px) {\n    .ql-editor {\n        padding-right: 0px;\n        padding-left: 0px;\n    }\n\n    .ql-editor.ql-editor-collapsed {\n        padding-right: 56px;\n        padding-left: 56px;\n    }\n}\n.ql-editor > * {\n    cursor: text;\n}\n.ql-editor .ql-markdownTable {\n    display: block;\n    margin: 12px 0;\n    max-width: 100%;\n    cursor: default;\n}\n.ql-editor .ql-markdown-table-scroll {\n    max-width: 100%;\n    overflow-x: auto;\n    padding-bottom: 2px;\n}\n.ql-editor .ql-markdown-table {\n    width: max-content;\n    min-width: min(100%, 320px);\n    max-width: 100%;\n    border-collapse: collapse;\n    border: 1px solid #d7dff0;\n    color: #04142f;\n    font-size: 14px;\n    line-height: 20px;\n    white-space: normal;\n}\n.ql-editor .ql-markdown-table th,\n.ql-editor .ql-markdown-table td {\n    min-width: 96px;\n    max-width: 280px;\n    border: 1px solid #d7dff0;\n    padding: 8px 10px;\n    vertical-align: top;\n    overflow-wrap: anywhere;\n}\n.ql-editor .ql-markdown-table th {\n    background-color: #f6f8fc;\n    font-weight: 700;\n}\n/* Quill 2 list DOM: every list renders as <ol>, the type lives in li[data-list]\n   (ordered | bullet | checked | unchecked), and the marker is drawn by the\n   contenteditable=false <span class=\"ql-ui\"> child. The app's custom metrics\n   (7.4px list padding, 1.82em item padding, 9.7px marker gap) are preserved on\n   the new selectors. */\n.ql-editor {\n    counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n    margin: 0;\n    padding: 0;\n}\n.ql-editor p,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n    counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n/* AT-2254: a numbered list must restart at 1 unless it directly continues an\n   ordered list. Quill 2's ListContainer only ever accepts ListItem children\n   (ListContainer.allowedChildren = [ListItem]), so ANY other block -- a\n   paragraph, heading, blockquote, code block, markdown table, divider or image\n   -- necessarily splits the list into a second <ol>. Resetting the counter on\n   the container therefore covers every possible separator, where the previous\n   `p, h1..h6` rule above covered only two of them and let a list that was\n   interrupted by anything else keep counting (1..6 at the top of a note, then\n   7.. much further down). Kept alongside that rule rather than replacing it:\n   it is what stock quill ships, and it costs nothing. */\n.ql-editor ol {\n    padding-left: 7.4px; /*Previous value was 0.25em*/\n    counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor li {\n    list-style-type: none;\n    position: relative;\n}\n.ql-editor li > .ql-ui::before {\n    display: inline-block;\n    white-space: nowrap;\n    width: 1.2em;\n    text-align: right;\n}\n.ql-editor li[data-list='ordered'] > .ql-ui::before {\n    margin-left: -1.65em;\n    margin-right: 0.45em;\n}\n.ql-editor li[data-list='bullet'] > .ql-ui::before {\n    content: '\\2022';\n    margin-left: -1.5em;\n    margin-right: 9.7px;\n}\n.ql-editor li[data-list='checked'] > .ql-ui,\n.ql-editor li[data-list='unchecked'] > .ql-ui {\n    color: #777;\n    cursor: pointer;\n    pointer-events: all;\n}\n.ql-editor li[data-list='checked'] > .ql-ui::before {\n    content: '\\2611';\n    margin-left: -1.5em;\n    margin-right: 9.7px;\n}\n.ql-editor li[data-list='unchecked'] > .ql-ui::before {\n    content: '\\2610';\n    margin-left: -1.5em;\n    margin-right: 9.7px;\n}\n.ql-editor li.ql-direction-rtl > .ql-ui::before {\n    margin-left: 0.3em;\n    margin-right: -1.5em;\n    text-align: left;\n}\n.ql-editor li:not(.ql-direction-rtl) {\n    padding-left: 1.82em;\n}\n.ql-editor li.ql-direction-rtl {\n    padding-right: 1.82em;\n}\n.ql-editor li[data-list] {\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n/* AT-2254: the one separator that does NOT split the <ol>. Quill 2 keeps\n   bullets, checkboxes and numbers in a single container and distinguishes them\n   only by li[data-list], so a bulleted or checklist run between two numbered\n   runs leaves them in the same <ol> and the container reset above never fires.\n   `counter-set` is deliberate: it touches list-0 alone, so it cannot collide\n   with the list-1..list-9 `counter-reset` cascade above and in the indent chain\n   below (same property + equal specificity would drop the nested resets). */\n.ql-editor li[data-list='bullet'],\n.ql-editor li[data-list='checked'],\n.ql-editor li[data-list='unchecked'] {\n    counter-set: list-0 0;\n}\n/* Safari < 17.2 has no counter-set. Falling back to counter-reset re-introduces\n   the collision described above, so an INDENTED bullet loses its list-1..list-9\n   reset there; top-level separation -- the reported bug -- still works. */\n@supports not (counter-set: none) {\n    .ql-editor li[data-list='bullet'],\n    .ql-editor li[data-list='checked'],\n    .ql-editor li[data-list='unchecked'] {\n        counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    }\n}\n.ql-editor li[data-list='ordered'] {\n    counter-increment: list-0;\n}\n.ql-editor li[data-list='ordered'] > .ql-ui::before {\n    content: counter(list-0, decimal) '. ';\n}\n.ql-editor li[data-list='ordered'].ql-indent-1 {\n    counter-increment: list-1;\n}\n.ql-editor li[data-list='ordered'].ql-indent-1 > .ql-ui::before {\n    content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor li[data-list].ql-indent-1 {\n    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-2 {\n    counter-increment: list-2;\n}\n.ql-editor li[data-list='ordered'].ql-indent-2 > .ql-ui::before {\n    content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor li[data-list].ql-indent-2 {\n    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-3 {\n    counter-increment: list-3;\n}\n.ql-editor li[data-list='ordered'].ql-indent-3 > .ql-ui::before {\n    content: counter(list-3, decimal) '. ';\n}\n.ql-editor li[data-list].ql-indent-3 {\n    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-4 {\n    counter-increment: list-4;\n}\n.ql-editor li[data-list='ordered'].ql-indent-4 > .ql-ui::before {\n    content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor li[data-list].ql-indent-4 {\n    counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-5 {\n    counter-increment: list-5;\n}\n.ql-editor li[data-list='ordered'].ql-indent-5 > .ql-ui::before {\n    content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor li[data-list].ql-indent-5 {\n    counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-6 {\n    counter-increment: list-6;\n}\n.ql-editor li[data-list='ordered'].ql-indent-6 > .ql-ui::before {\n    content: counter(list-6, decimal) '. ';\n}\n.ql-editor li[data-list].ql-indent-6 {\n    counter-reset: list-7 list-8 list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-7 {\n    counter-increment: list-7;\n}\n.ql-editor li[data-list='ordered'].ql-indent-7 > .ql-ui::before {\n    content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor li[data-list].ql-indent-7 {\n    counter-reset: list-8 list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-8 {\n    counter-increment: list-8;\n}\n.ql-editor li[data-list='ordered'].ql-indent-8 > .ql-ui::before {\n    content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor li[data-list].ql-indent-8 {\n    counter-reset: list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-9 {\n    counter-increment: list-9;\n}\n.ql-editor li[data-list='ordered'].ql-indent-9 > .ql-ui::before {\n    content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-ui {\n    position: absolute;\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3.32em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3.32em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3.32em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3.32em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 3.32em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 4.82em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 4.82em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 4.82em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 4.82em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 6.32em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 6.32em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 6.32em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 7.82em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 7.82em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 7.82em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 7.82em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 9.32em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 9.32em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 9.32em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 9.32em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 10.82em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 10.82em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 10.82em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 10.82em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 12.32em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 12.32em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 12.32em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 12.32em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 13.82em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 13.82em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 13.82em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 13.82em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 15.32em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 15.32em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 15.32em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 15.32em;\n}\n.ql-editor .ql-video {\n    display: block;\n    max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n    margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n    margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n    background-color: #000;\n}\n.ql-editor .ql-bg-red {\n    background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n    background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n    background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n    background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n    background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n    background-color: #93f;\n}\n.ql-editor .ql-color-white {\n    color: #fff;\n}\n.ql-editor .ql-color-red {\n    color: #e60000;\n}\n.ql-editor .ql-color-orange {\n    color: #f90;\n}\n.ql-editor .ql-color-yellow {\n    color: #ff0;\n}\n.ql-editor .ql-color-green {\n    color: #008a00;\n}\n.ql-editor .ql-color-blue {\n    color: #06c;\n}\n.ql-editor .ql-color-purple {\n    color: #93f;\n}\n.ql-editor .ql-font-serif {\n    font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n    font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n    font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n    font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n    font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n    direction: rtl;\n    text-align: inherit;\n}\n.ql-editor .ql-align-center {\n    text-align: center;\n}\n.ql-editor .ql-align-justify {\n    text-align: justify;\n}\n.ql-editor .ql-align-right {\n    text-align: right;\n}\n.ql-editorLoading.ql-blank::before {\n    color: rgba(0, 0, 0, 0.6) !important;\n}\n.ql-editor.ql-blank::before {\n    color: rgba(0, 0, 0, 0);\n    content: attr(data-placeholder);\n    font-style: italic;\n    left: 15px;\n    pointer-events: none;\n    position: absolute;\n    right: 15px;\n}\n@media only screen and (min-width: 1052px) {\n    .ql-editor.ql-blank::before {\n        padding-left: 88px;\n    }\n}\n@media only screen and (max-width: 1052px) {\n    .ql-editor.ql-blank::before {\n        padding-left: 40px;\n    }\n}\n@media only screen and (max-width: 819px) {\n    .ql-editor.ql-blank::before {\n        left: -40px;\n    }\n    .ql-editor.ql-editor-collapsed.ql-blank::before {\n        left: 0px;\n        padding-left: 56px;\n    }\n}\n.ql-snow.ql-toolbar:after,\n.ql-snow .ql-toolbar:after {\n    clear: both;\n    content: '';\n    display: table;\n}\n.ql-snow.ql-toolbar button,\n.ql-snow .ql-toolbar button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    float: left;\n    height: 20px;\n    padding: 0 6px;\n    min-width: 32px;\n}\n.ql-snow.ql-toolbar .ql-toolbar-item {\n    position: relative;\n}\n.ql-snow.ql-toolbar button svg,\n.ql-snow .ql-toolbar button svg {\n    float: left;\n    height: 100%;\n}\n.ql-snow.ql-toolbar button:active:hover,\n.ql-snow .ql-toolbar button:active:hover {\n    outline: none;\n}\n.ql-snow.ql-toolbar input.ql-image[type='file'],\n.ql-snow .ql-toolbar input.ql-image[type='file'] {\n    display: none;\n}\n.ql-snow.ql-toolbar button:hover,\n.ql-snow .ql-toolbar button:hover,\n.ql-snow.ql-toolbar button:focus,\n.ql-snow .ql-toolbar button:focus,\n.ql-snow.ql-toolbar button.ql-active,\n.ql-snow .ql-toolbar button.ql-active,\n.ql-snow.ql-toolbar .ql-picker-label:hover,\n.ql-snow .ql-toolbar .ql-picker-label:hover,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active,\n.ql-snow.ql-toolbar .ql-picker-item:hover,\n.ql-snow .ql-toolbar .ql-picker-item:hover,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n    color: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n    fill: #06c;\n}\n.ql-snow.ql-toolbar button:hover .ql-stroke,\n.ql-snow .ql-toolbar button:hover .ql-stroke,\n.ql-snow.ql-toolbar button:focus .ql-stroke,\n.ql-snow .ql-toolbar button:focus .ql-stroke,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n.ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n    stroke: #06c;\n    transition: 0.3s;\n}\n@media (pointer: coarse) {\n    .ql-snow.ql-toolbar button:hover:not(.ql-active),\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n        color: #444;\n    }\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n        fill: #444;\n    }\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n        stroke: #444;\n    }\n}\n.ql-snow {\n    box-sizing: border-box;\n}\n.ql-snow * {\n    box-sizing: border-box;\n}\n.ql-snow .ql-hidden {\n    display: none;\n}\n.ql-hide {\n    display: none !important;\n}\n.ql-transparent {\n    opacity: 0 !important;\n}\n.ql-snow .ql-out-bottom,\n.ql-snow .ql-out-top {\n    visibility: hidden;\n}\n.ql-snow .ql-tooltip {\n    position: absolute;\n    transform: translate(148px, 10px);\n}\n.ql-snow .ql-tooltip a {\n    cursor: pointer;\n    text-decoration: none;\n}\n.ql-snow .ql-tooltip.ql-flip {\n    transform: translateY(-10px);\n}\n.ql-snow .ql-formats {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n.ql-snow .ql-formats:after {\n    clear: both;\n    content: '';\n    display: table;\n}\n.ql-snow .ql-stroke {\n    transition: 0.3s;\n    fill: none;\n    stroke: #8a94a6;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 0.2px;\n}\n.ql-snow .ql-stroke-miter {\n    fill: none;\n    stroke: #444;\n    stroke-miterlimit: 10;\n    stroke-width: 2;\n}\n.ql-snow .ql-fill,\n.ql-snow .ql-stroke.ql-fill {\n    fill: #8a94a6;\n}\n.ql-snow .ql-empty {\n    fill: none;\n}\n.ql-snow .ql-even {\n    fill-rule: evenodd;\n}\n.ql-snow .ql-thin,\n.ql-snow .ql-stroke.ql-thin {\n    stroke-width: 1;\n}\n.ql-snow .ql-transparent {\n    opacity: 0.4;\n}\n.ql-snow .ql-direction svg:last-child {\n    display: none;\n}\n.ql-snow .ql-direction.ql-active svg:last-child {\n    display: inline;\n}\n.ql-snow .ql-direction.ql-active svg:first-child {\n    display: none;\n}\n.ql-snow .ql-editor h1 {\n    font-family: 'Roboto-Medium', 'Roboto-Regular';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 28px;\n    line-height: 36px;\n    letter-spacing: -0.01em;\n    color: #04142f;\n    margin-top: 24px;\n    margin-bottom: 8px;\n}\n.ql-snow .ql-editor h2 {\n    font-family: 'Roboto-Medium', 'Roboto-Regular';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 30px;\n    letter-spacing: 0em;\n    color: #1a2744;\n    margin-top: 20px;\n    margin-bottom: 6px;\n}\n.ql-snow .ql-editor h3 {\n    font-family: 'Roboto-Regular';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 26px;\n    letter-spacing: 0em;\n    color: #4e5d78;\n    margin-top: 16px;\n    margin-bottom: 4px;\n}\n/* Keep in-document heading rhythm, but avoid excessive top gap at the start of a note. */\n.ql-snow .ql-editor > h1:first-child,\n.ql-snow .ql-editor > h2:first-child,\n.ql-snow .ql-editor > h3:first-child {\n    margin-top: 8px;\n}\n.ql-snow .ql-editor h4 {\n    font-size: 1em;\n}\n.ql-snow .ql-editor h5 {\n    font-size: 0.83em;\n}\n.ql-snow .ql-editor h6 {\n    font-size: 0.67em;\n}\n.ql-snow .ql-editor a {\n    text-decoration: underline;\n}\n.ql-snow .ql-editor blockquote {\n    border-left: 4px solid #ccc;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding-left: 16px;\n}\n.ql-snow .ql-editor code,\n.ql-snow .ql-editor pre {\n    background-color: #f0f0f0;\n    border-radius: 3px;\n}\n.ql-snow .ql-editor pre {\n    white-space: pre-wrap;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding: 5px 10px;\n}\n.ql-snow .ql-editor code {\n    font-size: 85%;\n    padding: 2px 4px;\n}\n.ql-snow .ql-editor pre.ql-syntax {\n    background-color: #23241f;\n    color: #f8f8f2;\n    overflow: visible;\n}\n.ql-snow .ql-editor img {\n    max-width: 100%;\n}\n.ql-snow .ql-picker {\n    color: #4e5d78;\n    display: inline-block;\n    float: left;\n    font-size: 16px;\n    font-weight: normal;\n    height: 28px;\n    position: relative;\n    vertical-align: middle;\n    letter-spacing: 0.02em;\n}\n.ql-snow .ql-picker-label {\n    cursor: pointer;\n    display: flex;\n    height: 100%;\n    padding-left: 10px;\n    padding-right: 2px;\n    position: relative;\n    width: 100%;\n}\n.ql-color.ql-picker.ql-color-picker .ql-picker-label {\n    display: contents;\n}\n.ql-background.ql-picker.ql-color-picker .ql-picker-label {\n    display: contents;\n}\n.ql-snow .ql-picker-label::before {\n    display: inline-block;\n    line-height: 22px;\n}\n.ql-snow .ql-picker-options {\n    background-color: #fff;\n    display: none;\n    min-width: 100%;\n    padding: 4px 8px;\n    position: absolute;\n    white-space: nowrap;\n}\n.ql-snow .ql-picker-options .ql-picker-item {\n    cursor: pointer;\n    display: block;\n    padding-bottom: 5px;\n    padding-top: 5px;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    color: #ccc;\n    z-index: 2;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n    fill: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n    stroke: #ccc;\n}\n.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    display: block;\n    margin-top: -1px;\n    top: 100%;\n    z-index: 1;\n}\n.ql-snow .ql-color-picker,\n.ql-snow .ql-icon-picker {\n    width: 30px;\n}\n.ql-snow .ql-color-picker .ql-picker-label,\n.ql-snow .ql-icon-picker .ql-picker-label {\n    padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-label svg,\n.ql-snow .ql-icon-picker .ql-picker-label svg {\n    right: 4px;\n}\n.ql-snow .ql-icon-picker .ql-picker-options {\n    padding: 4px 0px;\n}\n.ql-snow .ql-icon-picker .ql-picker-item {\n    height: 24px;\n    width: 24px;\n    padding: 2px 4px;\n}\n.ql-snow .ql-color-picker .ql-picker-options {\n    padding: 8px 16px;\n    width: 187px;\n}\n@media (max-width: 818px) {\n    .ql-snow .ql-color-picker .ql-picker-options {\n        width: 152px;\n    }\n}\n.ql-snow .ql-color-picker .ql-picker-item .ql-color-item-text {\n    font-family: 'Roboto-Medium', sans-serif;\n    font-weight: 500;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #ffffff !important;\n    margin-left: 8px;\n}\n.ql-snow .ql-color-picker .ql-picker-item .ql-color-item-color {\n    display: inline-block;\n    border: 2px solid #ffffff;\n    border-radius: 50px;\n    width: 20px;\n    height: 20px;\n    margin: 0;\n    padding: 0px;\n}\n.ql-snow .ql-color-picker .ql-picker-item.ql-selected .ql-color-item-text {\n    color: #007fff !important;\n}\n.ql-snow .ql-color-picker .ql-picker-item.ql-selected .ql-color-item-color {\n    border-color: #007fff;\n}\n.ql-snow .ql-color-picker .ql-picker-item .ql-color-item-sub-container {\n    display: flex;\n    align-items: center;\n    position: relative;\n    flex-direction: row;\n    flex-grow: 1;\n    width: 100%;\n}\n.ql-snow .ql-color-picker .ql-picker-item {\n    background-color: transparent !important;\n    position: relative;\n    margin: 0;\n    padding: 10px 0;\n}\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker):not(.ql-header) svg {\n    position: absolute;\n    margin-top: -9px;\n    right: 20px;\n    top: 16px;\n    width: 18px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-options {\n    position: absolute;\n    top: 40px;\n    background-color: #091540;\n    padding: 8px 16px;\n    min-width: 200px;\n    height: 176px;\n    border-radius: 4px;\n}\n@media (max-width: 818px) {\n    .ql-snow .ql-picker.ql-header .ql-picker-options {\n        min-width: 160px;\n    }\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before {\n    transform: translate(5px, 8px);\n    content: attr(data-label);\n    height: 40px;\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n    content: attr(data-label);\n}\n.ql-snow .ql-picker.ql-header {\n    width: 12px;\n    height: 40px;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item::before {\n    content: 'Normal';\n}\n\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1'],\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2'],\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3'],\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=''] {\n    position: relative;\n    height: 40px;\n    margin: 0;\n    padding: 0;\n    border: none;\n}\n\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='']::before {\n    display: none;\n}\n\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1'],\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2'],\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3'],\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=''] {\n    position: relative;\n    height: 40px;\n    margin: 0;\n    padding: 0 0 0 32px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.ql-snow .ql-picker.ql-header .ql-picker-item .ql-header-item-icon {\n    position: absolute;\n    left: 0;\n    top: 8px;\n    width: 24px;\n}\n\n.ql-snow .ql-picker.ql-header .ql-picker-label .ql-header-item-icon {\n    position: absolute;\n    left: 0 !important;\n    top: 11px !important;\n    width: 20px !important;\n}\n\n.ql-snow .ql-picker.ql-header .ql-picker-label .ql-header-item-icon svg > path {\n    fill: #8a94a6 !important;\n    stroke: #8a94a6 !important;\n}\n\n.ql-snow .ql-picker.ql-header .ql-picker-item .ql-header-item-shortcut {\n    position: absolute;\n    top: 11px;\n    right: 0;\n}\n.ql-snow .ql-picker.ql-color .ql-picker-item .ql-color-item-shortcut,\n.ql-snow .ql-picker.ql-background .ql-picker-item .ql-color-item-shortcut {\n    position: absolute;\n    top: 3px;\n    right: 0;\n}\n\n@media (max-width: 818px) {\n    .ql-snow .ql-picker.ql-color .ql-picker-item .ql-color-item-shortcut,\n    .ql-snow .ql-picker.ql-background .ql-picker-item .ql-color-item-shortcut,\n    .ql-snow .ql-picker.ql-header .ql-picker-item .ql-header-item-shortcut {\n        display: none;\n    }\n}\n\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n    font-family: 'Roboto-Medium', sans-serif;\n    font-weight: 500;\n    font-size: 20px !important;\n    line-height: 28px !important;\n    color: #ffffff !important;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n    font-family: 'Roboto-Medium', sans-serif;\n    font-weight: 500;\n    font-size: 18px !important;\n    line-height: 26px !important;\n    color: #ffffff !important;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n    font-family: 'Roboto-Medium', sans-serif;\n    font-weight: 500;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #ffffff !important;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='']::before {\n    font-family: 'Roboto-Regular', sans-serif;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #ffffff !important;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n    content: 'Heading';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n    content: 'Subheading';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n    content: 'Small heading';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='']::before {\n    content: 'Normal text';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n    content: 'Heading 4';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n    content: 'Heading 5';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n    content: 'Heading 6';\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {\n    font-size: 2em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {\n    font-size: 1.5em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {\n    font-size: 1.17em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='']::before {\n    font-size: 1em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {\n    font-size: 1em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {\n    font-size: 0.83em;\n}\n.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {\n    font-size: 0.67em;\n}\n.ql-snow .ql-picker.ql-font {\n    width: 108px;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item::before {\n    content: 'Sans Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n    content: 'Serif';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n    content: 'Monospace';\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {\n    font-family: Georgia, Times New Roman, serif;\n}\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {\n    font-family: Monaco, Courier New, monospace;\n}\n.ql-snow .ql-picker.ql-size {\n    width: 98px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item::before {\n    content: 'Normal';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n    content: 'Small';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n    content: 'Large';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n    content: 'Huge';\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {\n    font-size: 10px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {\n    font-size: 18px;\n}\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {\n    font-size: 32px;\n}\n.ql-snow .ql-color-picker .ql-picker-options {\n    background-color: #091540;\n    border-radius: 4px;\n}\n.ql-snow .ql-color-picker.ql-background .ql-picker-item {\n    background-color: #fff;\n}\n.ql-snow .ql-color-picker.ql-color .ql-picker-item {\n    background-color: #000;\n}\n.ql-toolbar-container::-webkit-scrollbar {\n    display: none;\n}\n.ql-toolbar-container {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n    overflow: visible !important;\n    /*overflow-x: scroll;*/\n    /* width: 100%; */\n    /* margin-left: 72px; */\n    padding-right: 104px;\n    padding-left: 104px;\n    /*padding-bottom: 300px;*/\n    /*margin-bottom: -300px;*/\n}\n.ql-toolbar-scroll-indicator {\n    width: 48px;\n    height: 56px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #fafbfb;\n    box-shadow: -2px 0px 4px rgba(0, 0, 0, 0.08);\n    border-radius: 4px;\n    position: absolute;\n    right: 0px;\n}\n@media only screen and (min-width: 1098px) {\n    .ql-toolbar-scroll-indicator {\n        display: none;\n    }\n}\n@media only screen and (max-width: 1052px) {\n    .ql-toolbar-container {\n        padding-right: 56px;\n        padding-left: 56px;\n    }\n}\n@media only screen and (max-width: 819px) {\n    .ql-toolbar-container {\n        padding-right: 0px;\n        padding-left: 0px;\n    }\n\n    .ql-toolbar-container.ql-toolbar-container-collapsed {\n        padding-right: 56px;\n        padding-left: 56px;\n    }\n}\n.ql-toolbar.ql-snow {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-grow: 1;\n    border: 0px;\n    height: 56px;\n    /*min-width: 700px;*/\n    font-family: 'Roboto-Regular', serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.02em;\n    padding-left: 8px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    padding-right: 0px;\n\n    background: #fafbfb;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04), 0px 2px 3px rgba(0, 0, 0, 0.04);\n    border-radius: 4px;\n}\n.ql-toolbar.ql-snow .ql-formats {\n    margin-right: 15px;\n}\n.ql-toolbar.ql-snow .ql-formats2 {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-right: 7px;\n    margin-left: -5px;\n}\n\n.ql-toolbar.ql-snow .ql-formats3 {\n    display: flex;\n    flex-direction: row;\n    margin-right: 7px;\n    margin-left: -5px;\n}\n\n.ql-toolbar.ql-snow .ql-formats-editors {\n    margin-left: -15px;\n}\n\n.ql-toolbar.ql-snow .ql-picker-label {\n    border: 1px solid #c6cdd2;\n    border-radius: 4px;\n}\n.ql-toolbar.ql-snow .ql-picker-options {\n    border: 1px solid transparent;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    border-color: #ccc;\n}\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n    border-color: #000;\n}\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n    border-top: 0px;\n}\n.ql-snow .ql-tooltip {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0px 0px 5px #ddd;\n    color: #444;\n    padding: 5px 12px;\n    white-space: nowrap;\n}\n.ql-snow .ql-tooltip::before {\n    content: 'Visit URL:';\n    line-height: 26px;\n    margin-right: 8px;\n}\n.ql-snow .ql-tooltip input[type='text'] {\n    display: none;\n    border: 1px solid #ccc;\n    font-size: 13px;\n    height: 26px;\n    margin: 0px;\n    padding: 3px 5px;\n    width: 170px;\n}\n.ql-snow .ql-tooltip a.ql-preview {\n    display: inline-block;\n    max-width: 200px;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top;\n}\n.ql-snow .ql-tooltip a.ql-action::after {\n    border-right: 1px solid #ccc;\n    content: 'Edit';\n    margin-left: 16px;\n    padding-right: 8px;\n}\n.ql-snow .ql-tooltip a.ql-remove::before {\n    content: 'Remove';\n    margin-left: 8px;\n}\n.ql-snow .ql-tooltip a {\n    line-height: 26px;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-preview,\n.ql-snow .ql-tooltip.ql-editing a.ql-remove {\n    display: none;\n}\n.ql-snow .ql-tooltip.ql-editing input[type='text'] {\n    display: inline-block;\n}\n.ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n    border-right: 0px;\n    content: 'Save';\n    padding-right: 0px;\n}\n.ql-snow .ql-tooltip[data-mode='link']::before {\n    content: 'Enter link:';\n}\n.ql-snow .ql-tooltip[data-mode='formula']::before {\n    content: 'Enter formula:';\n}\n.ql-snow .ql-tooltip[data-mode='video']::before {\n    content: 'Enter video:';\n}\n.ql-snow a {\n    font-family: 'Roboto-Regular';\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.02em;\n    color: #007fff;\n    text-decoration: none;\n}\n\n.ql-snow a:link {\n    text-decoration: none;\n}\n.ql-container.ql-snow {\n    border: 0px;\n}\n\n.ql-custom-popup {\n    position: absolute;\n    top: 28px;\n    left: 28px;\n    background-color: #091540;\n    border-radius: 4px;\n    padding: 8px 16px;\n    white-space: nowrap;\n    z-index: 10000;\n}\n\n.ql-custom-popup .ql-custom-popup-item {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 40px;\n    justify-content: flex-start;\n    position: relative;\n}\n.ql-custom-popup .ql-custom-popup-text {\n    font-family: 'Roboto-Medium', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.01em;\n    color: #ffffff;\n    margin-left: 8px;\n    transition: 0.3s;\n}\n.ql-custom-popup .ql-custom-popup-text.ql-embed {\n    position: absolute;\n    top: 8px;\n    left: 24px;\n    width: 120px;\n    text-align: left;\n}\n.ql-custom-popup .ql-active .ql-custom-popup-text.ql-embed {\n    color: #007fff;\n}\n.ql-custom-popup .ql-custom-popup-item .ql-active svg path {\n    fill: #007fff !important;\n    stroke: #007fff;\n}\n.ql-custom-popup .ql-custom-popup-item svg path {\n    fill: #ffffff !important;\n    stroke: #ffffff;\n}\n\n.ql-custom-popup .ql-custom-popup-item .ql-picker .ql-custom-popup-text.ql-embed {\n    top: 4px;\n}\n\n.ql-custom-popup .ql-custom-popup-item .ql-picker .ql-picker-label .ql-custom-popup-text.ql-embed {\n    top: 0;\n}\n\n.ql-custom-popup .ql-custom-popup-item .ql-picker .ql-picker-label svg {\n    top: -4px;\n    position: relative;\n    left: -4px;\n    width: 32px;\n}\n\n.ql-custom-popup .ql-custom-popup-item button {\n    padding: 0px;\n}\n\n.ql-custom-popup .ql-custom-popup-item .ql-picker-options {\n    width: 180px;\n    top: -16px !important;\n    left: -14px;\n}\n\n/* Cell editing stays inside the existing table; controls wrap on phones. */\n.ql-editor[contenteditable='true'] .ql-markdown-table [data-row][data-column] {\n    cursor: text;\n}\n.ql-editor .ql-markdown-table [data-row][data-column]:focus,\n.ql-editor .ql-markdown-table [data-row][data-column]:focus-within {\n    outline: 2px solid #8a9eff;\n    outline-offset: -2px;\n}\n.ql-editor .ql-table-cell-input {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 76px;\n    margin: 0;\n    padding: 0;\n    border: none;\n    border-radius: 0;\n    outline: none;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    text-align: inherit;\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n    overflow: hidden;\n    resize: none;\n    min-height: 20px;\n}\n.ql-editor .ql-markdown-table th,\n.ql-editor .ql-markdown-table td {\n    white-space: pre-wrap;\n}\n.ql-editor .ql-table-controls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    padding: 6px 0;\n    white-space: normal;\n}\n.ql-editor .ql-table-controls button,\n.ql-container .ql-table-draft-recovery button {\n    padding: 5px 8px;\n    border: 1px solid #d7dff0;\n    border-radius: 4px;\n    background: #f6f8fc;\n    color: #04142f;\n    font: inherit;\n    font-size: 12px;\n    cursor: pointer;\n}\n.ql-editor .ql-table-controls button[aria-pressed='true'] {\n    background: #e8edff;\n    border-color: #8a9eff;\n}\n.ql-editor .ql-table-controls button:disabled {\n    opacity: 0.45;\n    cursor: default;\n}\n.ql-container.ql-disabled .ql-table-controls {\n    display: none;\n}\n.ql-container .ql-table-draft-recovery {\n    padding: 12px;\n    margin: 12px 0;\n    border: 1px solid #d7dff0;\n    border-radius: 4px;\n    background: #f6f8fc;\n}\n.ql-container .ql-table-draft-recovery textarea {\n    box-sizing: border-box;\n    width: 100%;\n    padding: 8px;\n    margin: 8px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
